<template>
  <el-card class="logistics-card">
    <el-form :model="logisticsForm" >
      <el-form-item :label="$t('mobile.toDoList.reasion')">
        <el-select
            v-model="formInline.channelId"
            filterable
            reserve-keyword
            :placeholder="$t('mobile.toDoList.rprompt')"
            remote-show-suffix
            :loading="loading"
            style="width: 200px"
        >
          <el-option
              v-for="item in channelList"
              :key="item.value"
              :label="item.label"
              :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item  :label="$t('mobile.toDoList.reasions')">
        <el-input rows="3" v-model="formInline.sendNumber" :placeholder="$t('mobile.toDoList.reasionM')"  style="width: 200px" type="textarea"  ></el-input>
      </el-form-item>
      <div class="flex flex-row-center">
        <el-button  type="primary"  @click="syncLogistics">{{$t('mobile.toDoList.delay')}}</el-button>
      </div>

    </el-form>
  </el-card>
</template>

<script>
import {ElButton,ElForm,ElFormItem,ElSelect,ElOption,ElInput,ElMessage} from "element-plus";
import {toDoDelay} from "@/utils/api";
export default {
  name: "toDoList",
  components:{
    ElButton,ElForm,ElFormItem,ElSelect,ElOption,ElInput
  },
  data() {
    return {
      lang: this.$i18n.locale,
      formInline: {
        sendSaleNumber:"",
        channelId:"",
        sendNumber:"",
        reasonCN:"",
        reasonEN:"",
      },
      channelList:[],
    };
  },
  beforeMount() {
    this.formInline.receiveSaleType = this.$route.query.receiveSaleType;
    this.formInline.recordId = this.$route.query.recordId;
    this.formInline.receiveSaleNumber = this.$route.query.receiveSaleNumber;
    if (this.lang === 'en') {
      this.channelList = [
        {id:1,label: 'Delivered', value: '已签收'},
        {id:2,label: 'Not yet received', value: '暂未到件'},
        {id:3,label: 'Others', value: ''},
      ]
    }else{
      this.channelList = [
        {id:1,label: '已签收', value: 'Delivered'},
        {id:2,label: '暂未到件', value: 'Not yet received'},
        {id:3,label: '其它', value: ''},
      ]
    }
  },
  methods: {
    syncLogistics() {
      if (!this.formInline.recordId && !this.formInline.receiveSaleNumber){
        ElMessage.error(this.$t('mobile.toDoList.return'))
        return
      }

      if (!this.formInline.channelId){
        ElMessage.error(this.$t('mobile.toDoList.rprompt'))
        return
      }
      let curSelect = this.channelList.find(item=>{
        return item.id == this.formInline.channelId
      })
      console.log(curSelect)
      if (this.lang==='en'){
        this.formInline.reasonCN = curSelect.value
        this.formInline.reasonEN = curSelect.label
      }else{
        this.formInline.reasonCN = curSelect.label
        this.formInline.reasonEN = curSelect.value
      }
      if (curSelect.id === 3){
        this.formInline.reasonCN = "其它"
        this.formInline.reasonEN = 'Others'
      }
      if (this.formInline.channelId == 4 && !this.formInline.sendNumber){
        if (!this.formInline.sendNumber){
          ElMessage.error(this.$t('mobile.toDoList.reasionM'))
          return
        }
      }
      this.formInline.remarks = this.formInline.sendNumber

      toDoDelay(this.formInline).then(res=>{
        ElMessage.success(this.$t('saveSuccess') )
        // 等待1秒
        setTimeout(() => {
          this.$router.push('/toDoList');
        }, 1000);
        console.log(res)
      }).catch(err=>{
        console.log(err)
      })
    }
  }
};
</script>

<style scoped>
.logistics-card {
  margin: 20px;
  padding: 20px;
  border-radius: 10px;
}
</style>
